import React, { useState, useEffect, Fragment } from 'react';
import { useQuery } from 'react-query';
import { find } from 'lodash';

import { Loader } from 'components';
import ShoppingExperience from '../containers/shopping/experience/item';

export default function ExperienceEdit({ ...props }) {
    const bag = useQuery('bag')?.data || [];

    const [update, setUpdate] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [data, setData] = useState([]);

    const id = props.match.params.id;

    useEffect(() => {
        setData(find(bag, { index: id }));
        if (update) setUpdate(false);
        setInitialLoading(false);

    }, [update, id]);

    return (
        <Fragment>

            {initialLoading ? (
                <Loader />
            ) : (
                <div className="page-wrapper page-amount" >
                    <ShoppingExperience
                        color={data.color}
                        experience={data}
                    />
                </div>
            )}
        </Fragment >
    )
}
